import { render } from "./TestCasesTable.vue?vue&type=template&id=1c106b3e&scoped=true"
import script from "./TestCasesTable.vue?vue&type=script&lang=js"
export * from "./TestCasesTable.vue?vue&type=script&lang=js"

import "./TestCasesTable.vue?vue&type=style&index=0&id=1c106b3e&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c106b3e"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
